import {cva} from 'class-variance-authority'

/**
 * Badge: a small status pill / dot — the count badge shown on a nav tab.
 *
 * - `severity` — semantic color role (success/flagged/info/error/cta/secondary).
 * - `variant` — `counter` (a pill containing a count) or `dot` (a bare 8px circle).
 *
 * Counter renders a solid color background with white (`text/inverse`) text for
 * every severity, per Figma. Dot renders the solid color background only (no text).
 */
export const BadgeVariantsFactory = cva('font-sans', {
  variants: {
    severity: {
      success: '',
      flagged: '',
      info: '',
      error: '',
      cta: '',
      secondary: '',
    },
    variant: {
      counter:
        'inline-flex items-center justify-center rounded-pill p-1 min-w-5 h-5 text-[12px] font-bold leading-[14px] text-center',
      dot: 'inline-block size-2 rounded-full',
    },
  },
  compoundVariants: [
    // --- counter: solid bg + white text (text/inverse) for every severity ---
    {severity: 'success', variant: 'counter', class: 'bg-success text-white'},
    {severity: 'flagged', variant: 'counter', class: 'bg-flagged text-white'},
    {severity: 'info', variant: 'counter', class: 'bg-info text-white'},
    {severity: 'error', variant: 'counter', class: 'bg-error text-white'},
    {severity: 'cta', variant: 'counter', class: 'bg-cta text-white'},
    {severity: 'secondary', variant: 'counter', class: 'bg-secondary-dark text-white'},
    // --- dot: solid bg only ---
    {severity: 'success', variant: 'dot', class: 'bg-success'},
    {severity: 'flagged', variant: 'dot', class: 'bg-flagged'},
    {severity: 'info', variant: 'dot', class: 'bg-info'},
    {severity: 'error', variant: 'dot', class: 'bg-error'},
    {severity: 'cta', variant: 'dot', class: 'bg-cta'},
    {severity: 'secondary', variant: 'dot', class: 'bg-secondary-dark'},
  ],
  defaultVariants: {
    severity: 'flagged',
    variant: 'counter',
  },
})
